
import PreEntryApi from '../../assets/js/preentry'
import { i18nHelper } from '@it-common/lbp_common'
import OnboardHeader from '../OnboardHeader'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'

export default {
components: {
XButton,
Group,
Cell,
XInput,
PopupRadio,
Loading,
Datetime,
XTextarea,
Confirm,
OnboardHeader
},
data () {
return {
id: '',
trainList: [],
showLoading: true,
deleteRowsConfirm: false,
deleteCurIndex: '',
degreeItems: [
{ key: 1, value: this.$tsg('从业资格证') },
{ key: 2, value: this.$tsg('职业资格证') },
{ key: 3, value: this.$tsg('证书') }
],
no_training: 1,
code: '',
mobileFlag: false
}
},
created () {
this.id = this.$route.query.id
this.mobileFlag = this.isMobile()
this.$forceUpdate()


var localStorage = window.localStorage
this.code = localStorage.getItem('pre_code')
i18nHelper.loadLanguagePack(4159)
i18nHelper.setFixedLocale(localStorage.getItem('offer_zh'))
this.$forceUpdate()

if (!this.code || !this.id) {
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}

PreEntryApi.checkLogin(
{ id: this.id, code: this.code },
data => {
if (data && data.isSubmit === true) {
this.$router.push({ name: 'onboard.preview', query: { id: this.id } })

}
},
err => {
this.showLoading = false
if (err === -2) {
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}
},
() => {
this.showLoading = false
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
},
() => {
this.showLoading = false
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}
)


PreEntryApi.getStatusValue({ id: this.id, code: this.code }, data => {
if (data) {
this.no_training = data.no_training
}
})

PreEntryApi.getExperience(
{ id: this.id, getField: 'train_experience', code: this.code },
data => {
if (data) {
this.trainList = data
} else {
this.addTrain()
}
this.showLoading = false
},
code => {
if (code === -1) {
this.addTrain()
}
this.showLoading = false
},
() => {
this.showLoading = false
},
() => {
this.showLoading = false
}
)
},
methods: {
changeQuitDate (startDate, endDate) {
if (startDate !== null && endDate !== null) {
if (endDate < startDate) {
this.$message.error(this.$tsg('结束时间必须大于等于开始时间'))
}
}
},
isMobile () {
if (/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)) {
return true
}
return false
},
deleteRows (key) {
this.deleteRowsConfirm = true
this.deleteCurIndex = key
},
sendDel () {
this.trainList.splice(this.deleteCurIndex, 1)
this.sendMaterial(3)
},
changeTrainStatus () {
this.no_training = this.no_training === 1 ? 2 : 1

if (this.no_training === 2) {
this.trainList = []
PreEntryApi.saveExperience(
{
id: this.id,
code: this.code,
train_experience: this.trainList,
saveField: 'train_experience'
},
data => {
if (data !== '') {
this.$message.error(this.$tsg('资料信息更新失败。'))
return false
}
},
() => {
this.$message.error(this.$tsg('资料信息更新失败。'))
}
)
if (this.trainList.length === 0) {
this.addTrain()
}
} else {
if (this.trainList.length === 0) {
this.addTrain()
}
}

PreEntryApi.updateStatusValue(
{
id: this.id,
code: this.code,
field: 'no_training',
no_training: this.no_training
},
() => {},
() => {
this.$message.error(this.$tsg('状态字段更新失败。'))
}
)
},
showStep () {
this.hasShowPopup.data = !this.hasShowPopup.data
},
removeTrain () {
this.trainList.pop()
},
addTrain () {
this.trainList.push({
entry_date: '',
quit_date: '',
train_institution: '',
train_content: '',
education: ''
})
},

getIsZh (data) {
var localStorage = window.localStorage
if (data) {
localStorage.setItem('offer_zh', 'zh')

} else {
localStorage.setItem('offer_zh', 'en')

}
this.isZH = data
},
sendMaterial (returnFlag) {
if (!this.id) {
this.$message.error(this.$tsg('非法操作。'))
return false
}


var listLength = this.trainList.length,
trainList = []
for (var i = 0; i < listLength; i++) {
if (this.trainList[i].entry_date !== null && this.trainList[i].quit_date !== null) {
if (this.trainList[i].entry_date > this.trainList[i].quit_date) {
this.$message.error(this.$tsg('结束时间必须大于等于开始时间'))
return false
}
}
if (
this.trainList[i]['entry_date'] ||
this.trainList[i]['quit_date'] ||
this.trainList[i]['train_institution'] ||
this.trainList[i]['train_content'] ||
this.trainList[i]['education']
) {
trainList.push(this.trainList[i])
}
}

if (this.no_training === 2) {
this.trainList = []
}


PreEntryApi.saveExperience(
{
id: this.id,
code: this.code,
train_experience: trainList,
saveField: 'train_experience'
},
data => {
if (data !== '') {
this.$message.error(this.$tsg('资料信息更新失败。'))
return false
}


if (returnFlag === 2) {
this.$router.push({
name: 'onboard.upload',
query: { id: this.id }
})
} else if (returnFlag === 1) {
this.$router.push({ name: 'onboard.list', query: { id: this.id } })
} else if (returnFlag === 3) {

}
},
() => {
this.$message.error(this.$tsg('资料信息更新失败。'))

}
)
}
}
}



// WEBPACK FOOTER //
// ./src/components/onboard/train.vue